const WALLET_URL = `${process.env.API_V4_HOST}/wallet`;
const EXCLUSIVE_API = `${process.env.API_V4_HOST}/_exclusive`;
const DANA_PROFILE_API = `${EXCLUSIVE_API}/e-wallets/dana/profile`;

export const retrieveWalletMutations = ($axios, params) => $axios.$get(`${WALLET_URL}/mutations`, { params });

export const fetchDanaProfile = $axios => $axios.$get(`${DANA_PROFILE_API}`);

export const updateDanaBound = ($axios, params) => {
  const { oldNumber, newNumber } = params;
  const payload = { old_phone_no: oldNumber, new_phone_no: newNumber };
  $axios.$patch(`${DANA_PROFILE_API}/phone`, { ...payload });
};
